import type { Point, Rect } from '@os/engine';

export const MINIMAP_SIZE = { w: 200, h: 140 };
const MARGIN = 8;

/** Screen transform of the minimap: content and viewport both fit, centred, with an 8 px margin. */
export function minimapTransform(content: Rect | null, view: Rect, size: { w: number; h: number } = MINIMAP_SIZE): { scale: number; dx: number; dy: number } {
  const u = content
    ? { minX: Math.min(content.minX, view.minX), minY: Math.min(content.minY, view.minY), maxX: Math.max(content.maxX, view.maxX), maxY: Math.max(content.maxY, view.maxY) }
    : view;
  const uw = Math.max(1, u.maxX - u.minX);
  const uh = Math.max(1, u.maxY - u.minY);
  const scale = Math.min((size.w - 2 * MARGIN) / uw, (size.h - 2 * MARGIN) / uh);
  return { scale, dx: MARGIN + (size.w - 2 * MARGIN - uw * scale) / 2 - u.minX * scale, dy: MARGIN + (size.h - 2 * MARGIN - uh * scale) / 2 - u.minY * scale };
}

export const minimapToWorld = (t: { scale: number; dx: number; dy: number }, p: Point): Point => ({ x: (p.x - t.dx) / t.scale, y: (p.y - t.dy) / t.scale });
